import React from 'react';
import TableNavChange from '../tableNavChange/tableNavChange.jsx';
import Loading from '../showLoading/showLoading.jsx';
import "./index.less";
import { debounceOther,requests,messageShow,fromClassName,isNotNull } from '../../utils/http.js';
import { huoyuanLink } from '../../utils/index';
import { Select,Button,DatePicker} from 'element-react';
import SelectCategoryModule from '../selectCategoryModule/index.jsx';
import $ from 'jquery';
import ShowModal from '../showModal/index.jsx';
import SelectBox from '../selectBox/index.jsx';
import { GetCategoryBrandsRequest, PlatformUploadImageRequest} from '../../utils/api.js';
import dayjs from 'dayjs';

class ListingProductEditV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      productId: props.products == null ? "" : props.products.supplierProductId,
      products: props.products,
      isLoading: false,
      distributionStatus: [
        { id: 0, value: "infos", title: "基础数据", active: true, num: "" },
        { id: 1, value: "skuAndPrice", title: "SKU&价格", active: false, num: "" },
        { id: 2, value: "imageUpload", title: "图片", active: false, num: "" }
      ],
      indexs: 0,//0是基础数据，1是sku和价格
      showSelectCategoryModule: false, //是否显示类目录下拉框
      targetPlatformType: props.products == null ? "" : props.products.targetPlatformType,       //对应所在的平台
      targetShopId: props.products == null ? "" : props.products.targetShopId,            //重新铺货商品 对应所在的店铺

      productEditTaskCode: { taskCode: '', isPost: false },//铺货后，返回的任务code
      supplierProduct: {},
      sourceSupplierProduct: {},//供应商商品原信息

      catePropsList: [],//属性列表
      salesPropList: [],//销售属性
      skuList: [],
      batchSetPriceDailog: false,
      batchSetStockDailog: false,
      toutiaoSkuClassType: [
        { id: 0, name: '请选择', value: '' },
        { id: 0, name: '主售款（单品）', value: 'main_sale_single_product' },
        { id: 0, name: '主售款(多件装)', value: 'main_sale_multi_product' },
        { id: 0, name: '主售款（组合品)', value: 'main_sale_combination' },
        { id: 0, name: '非主售款', value: 'non_main_sale' },
        { id: 0, name: '信息说明/防拍', value: 'information_description' },
      ],
      recommondCateList: [],
      productImages: [],  // 主图
      productThreeAndFourImages: [], // 3:4主图
      whiteBackgroundImages: [], // 白底图
      productDetailImages: [], // 商品详情
      isMustProductThreeAndFourImages: false,
      openImageBigModal: false,
      currentImage: ""
    };
    var step = props.products && props.products.step
    if(step == 'editPrice'){
      this.state.indexs = 1;
      this.state.distributionStatus[0].active = false
      this.state.distributionStatus[1].active = true
    }
    this.state.supplierProduct.Title = props.products && props.products.title

    // this.setData();
  }
  componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
    this.setState({
      productId: props.products == null ? "" : props.products.supplierProductId,
      targetShopId: props.products == null ? "" : props.products.targetShopId,
      targetPlatformType: props.products == null ? "" : props.products.targetPlatformType,
    })
  }
  componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。




    this.loadData();



  }



  selectCategory = (cateList, selecCatetTitle) => {
    if (!cateList) return;

    let tempCatePathList = cateList.map(x => { return { CateId: x.Id, CateName: x.Name } });
    //如果类目选择的为相同类目则不更改相关内容
    if (this.state.catePathList && this.state.catePathList.length > 0 && cateList[cateList.length - 1].Id == this.state.catePathList[this.state.catePathList.length - 1].CateId)
      return;

    this.state.tempCatePathList = tempCatePathList;

    if(this.state.targetPlatformType == 'TouTiao'||this.state.targetPlatformType == 'KuaiShou'){
      //选择过类目需要提示用户是否确定更换
      if(this.state.tempCatePathList && this.state.tempCatePathList.length > 0){
        this.state.confirmUpdateCategory = true;
        this.state.showSelectCategoryModule = false;
        this.setState({});
      }else{
        this.confirmChangeCategory()
      }
    }
    this.state.catePathList = tempCatePathList;
    this.setState({
      showSelectCategoryModule: false
    })


  }
  confirmChangeCategory = () => {

    this.state.catePathList = this.state.tempCatePathList;

    this.setState({
      confirmUpdateCategory: false,
      showSelectCategoryModule: false
    }, () => {
      this.loadData();
    })
  }

  
  async GetListingProductByCateId(catePath){
    if(typeof this.props.changeCate != 'function')
      return
    let listingProduct = {
      Title: this.state.supplierProduct.Title,
      CatePathList:catePath || this.state.catePathList,
      CateProps: this.state.catePropsList,
      SalesProps: this.state.salesPropList,
      Skus: this.state.skuList,
      RelationCode:this.state.RelationCode
    }
    var product = await this.props.changeCate(listingProduct)
    if(product){
      product.SalesProps = product.SalesProps || []
      product.Skus = product.Skus || []

      product.SalesProps.forEach(x => {
        x.Value = x.Value || []
      })
      product.Skus.forEach(x => {
        x.AttributesList = x.AttributesList || []
      })


      this.setState({
        salesPropList: product.SalesProps,
        supplierProduct: product,
        catePropsList: product.CateProps,
        catePathList: product.CatePathList,
        confirmUpdateCategory: false,
        showSelectCategoryModule: false,
      }, () => {
        this.initSkuList(product.SalesProps, product.Skus)
      });
    }
  }
  showSelectCategoryModule = (e) => {
    this.setState({
      showSelectCategoryModule: true
    })
  }
  stopM = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }



  loadData = () => {
    this.setState({ isLoading: true });
    var that = this;
    var products = this.state.products;

    var data = {
      //TargetShopIds: products.targetShopId,
      //TargetPlatformType: products.targetPlatformType,
      TargetShopIds: this.state.targetShopId,
      TargetPlatformType: this.state.targetPlatformType,
      TaskCode: products.taskCode,
      RelationCode: products.relationCode,
      SupplierProductId: this.state.productId,
      SourcePlatform: products.sourcePlatform,
      ProductTag: products.supplierProductTag,
      CatePathList:this.state.catePathList || products.catePathList,
    };

    var that = this;
    requests({
      url: "/BatchDistribution/GetListingProductEditByAllPlatfromType",
      data: data,
      success: function (res) {
        if (res.RequestError == true) {//请求失效了。isLoading关闭看需求写
          that.setState({ isLoading: false });
          return;
        }

        if (res.Success) {
          var productEditDataList = res.Data.ProductEditDataList;
          var supplierProducts = res.Data.SupplierProducts;
          var taskCode = res.Data.TaskCode;

          that.state.sourceSupplierProduct = supplierProducts && supplierProducts.length > 0 ? supplierProducts[0] : null;
          if (taskCode == "") {
            that.setState({ isLoading: false });
            if (productEditDataList.length > 0) {
              var product = productEditDataList[0];
              
              product.SalesProps = product.SalesProps || []
              product.Skus = product.Skus || []

              product.SalesProps.forEach(x => {
                x.Value = x.Value || []
              })
              product.Skus.forEach(x => {
                x.AttributesList = x.AttributesList || []
              })
             
              if(that.state.supplierProduct.Title)
              {
                product.Title = that.state.supplierProduct.Title
              }
              that.initSkuList(product.SalesProps, product.Skus)

              if (product.RecommondCateList && product.RecommondCateList.length > 0) {
                product.RecommondCateList.forEach(function (item) {
                    let strL = 0;
                    item.CateItems.forEach(function (cItem) {
                        strL += cItem.Name.length
                    });
                    item.strLength = strL;
                });
              }

              that.setState({
                supplierProduct: product,
                catePropsList: product.CateProps,
                catePathList: product.CatePathList,
                salesPropList: product.SalesProps,
                skuList: product.Skus,
                recommondCateList: product.RecommondCateList,
                platformRecommendId:product.PlatformRecommendId
              }, () => {
                
                that.checkeSaleProps(that.state.salesPropList)
                that.checkTitle(product,false);
                
                product.CateProps.forEach(p=>{
                  if(p.FieldType == "multiValueMeasure")
                     that.setMultiValueMeasureValue(p);
                })
                
              });
            }
            else
              messageShow("未获取到数据，请关闭弹窗后重试！",'error');
          }
          else {

            var taskCodeRes = that.state.productEditTaskCode;   //:{taskCode:'',isPost:false,successNumber:0,errorNumber:0,errorList:[]}
            taskCodeRes.taskCode = taskCode;
            taskCodeRes.isPost = true;

            //任务轮询
            that.setState({
              productEditTaskCode: taskCodeRes
            }, () => {
              that.getListingProductEditPostTaskCode();
            });
            //that.setState({ isLoading: false });
          }

          if(productEditDataList.length > 0 && that.state.targetPlatformType=="KuaiShou") {
            let ImageInfo = productEditDataList[0].ImageInfo;
            that.setState({
                productImages: ImageInfo ? ImageInfo.ProductImages : [],
                productThreeAndFourImages: ImageInfo ? ImageInfo.ProductThreeAndFourImages : [],
                whiteBackgroundImages: ImageInfo ? ImageInfo.WhiteBackgroundImages : [],
                productDetailImages: ImageInfo ? ImageInfo.ProductDetailImages : [],
                isMustProductThreeAndFourImages: ImageInfo ? ImageInfo.IsMustProductThreeAndFourImages : false
            });
        }
        } else {
          that.setState({ isLoading: false });
          messageShow( "获取货源数据错误：" + res.Message,'error');
        }
      },
    });
  }

  //轮巡  铺货任务的处理。
  getListingProductEditPostTaskCode = () => {
    var taskCodeRes = this.state.productEditTaskCode;
    var that = this;
    requests({
      url: "/Common/GetZhuKeReqTask",
      data: { TaskCode: taskCodeRes.taskCode },
      success: function (res) {
        //关闭动画
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
          that.setState({ isLoading: false });
          taskCodeRes.isPost = false;
          taskCodeRes.taskCode = '';
          that.setState({ isLoading: false, taskCodeRes: taskCodeRes })
          return false;
        }
        if (res.Success) {
          var dates = res.Data;
          if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
            if (dates.Status == "Error" && dates.ErrorMsg != null && dates.ErrorMsg != undefined && dates.ErrorMsg != "") {
              messageShow("获取货源数据错误：" + dates.ErrorMsg,'error');
              taskCodeRes.isPost = false;
              taskCodeRes.taskCode = '';
              that.setState({ isLoading: false, taskCodeRes: taskCodeRes });
            } else {
              var relationCode = dates.RspContent;
              that.loadDataByRelationCode(relationCode);
            }
          } else {
            setTimeout(() => {
              that.getListingProductEditPostTaskCode();
            }, 1000);
          }
        } else {
          messageShow("获取货源数据错误：" + res.Message,'error');
          taskCodeRes.isPost = false;
          taskCodeRes.taskCode = '';
          that.setState({ isLoading: false, taskCodeRes: taskCodeRes });
        }
      },
    });
  }
  //批量设置价格
  batchSetPrice = () => {
    var selectBatchSetPriceRadio = $('input[name=batchSetPriceRadio]:checked').val();

    if (selectBatchSetPriceRadio == 'setDecimals') {
      let priceStr = $('#setDecimals').val();
      let price = parseInt(priceStr);
      if (price > 0) {
        this.state.skuList.forEach(x => {
          if (x.Price) {
            x.Price = parseInt(x.Price) + '.' + price;
          }
        })
      }
    } else if (selectBatchSetPriceRadio == 'unifiedPrice') {
      let priceStr = $('#unifiedPrice').val();
      let price = parseFloat(priceStr);
      if (price > 0) {
        this.state.skuList.forEach(x => { x.Price = price; })
      }
    } else if (selectBatchSetPriceRadio == 'comparePrice') {
      let ratio = parseFloat($('#comparePriceRatio').val());
      let add = parseFloat($('#comparePriceAdd').val());
      if (!ratio) ratio = 100.0
      if (!add) add = 0;
      this.state.skuList.forEach(x => {
        if (x.Price) {
          x.Price = (parseFloat(x.Price) * (ratio / 100) + add).toFixed(2);
        }
      })
    }
    else if (selectBatchSetPriceRadio == 'compareSourcePrice') {
      let ratio = parseFloat($('#compareSourcePriceRatio').val());
      let add = parseFloat($('#compareSourcePriceAdd').val());
      if (!ratio) ratio = 100.0
      if (!add) add = 0;
      this.state.skuList.forEach(x => {
        if (x.SourcePrice) {
          x.Price = (parseFloat(x.SourcePrice) * (ratio / 100) + add).toFixed(2);
        }
      })
    }
    this.cancelModule("batchSetPriceDailog")
  }
  setPrice = (item, val) => {
    if (val) {
      const match = /^\d+.{0,1}\d{0,}$/.test(val)
      if (!match)
        val = item.Price
    }
    item.Price = val;
    this.setState({})
  }
  setTitle = (item, val) => {
    // if (this.getStrByteCnt(val) > 60 && val.length > item.Title.length) {
    //   return
    // }
    item.Title = val;
    this.debounceOtherCheckTitle(item)
    this.setState({})
  }
  debounceOtherCheckTitle = debounceOther((item)=>{
    this.checkTitle(item)
    this.setState({})
  })
  checkTitle(item,showError = true)
  {
    item.titleError = false
    const len = this.getStrByteCnt(item.Title);
    if(len > 60) {
      item.titleError = true
      if(showError)
        messageShow('标题字数需控制在30字(60字符)以内','error')
    }
  }
  
  checkCateProps(item){
    var isOk=true;
    for (let index = 0; index < item.length; index++) {
      var x = item[index];
      var errorMessage="";
      if(x.FieldType == "multiValueMeasure")//检测抖音度量衡，填写值的情况
      {
        var allNumber=0;
        x.MeasureTemplates.MultiValueMeasureList.forEach(f=>{
            if(isNotNull(f.Name) ==false)
               errorMessage="面料材质=>属性值不能为空";
            
            try{
              allNumber=allNumber+JSON.parse(f.Value);
            }catch(eee){}
        });

        if(allNumber !=100)
          errorMessage="面料材质=>百分比相加需要等于100%";
        
        if(errorMessage !="")
        {
          isOk=false;
          messageShow(errorMessage,'error')
        }
      }
      if (x.FieldType == "measure" && (x.Rule && x.Rule.IsRequired)) {
        if (isNotNull(x.MeasureTemplates.LeftValue) == false) {
          errorMessage = x.Name+'不能为空'
        }
       
        if(errorMessage !="")
        {
          isOk=false;
          messageShow(errorMessage,'error')
        }
      }
      if (x.Rule && x.Rule.IsRequired && !x.MeasureTemplates) {
        if (isNotNull(x.Value) == false) {
          errorMessage = x.FieldType == 'singleCheck'?'请选择'+ x.Name:'请填写'+ x.Name;
          isOk=false;
          messageShow(errorMessage,'error')
          return isOk;
        }
        
      }
    }
    
    return isOk;
  }
  //验证当前是否必须
  checkPropIsMust(item)
  {
   
    try{
     var reuslt=false;
     if(item.PreProp!=null&&item.PreProp.length>0)
     {
      item.PreProp.forEach(element => {
         this.state.catePropsList.map((item) =>{
            if(item.PropId==element.PropID)
            {
              element.PropValue.map((item1) =>{
                 if(item1.SelectValue==item.Value){
                    reuslt=true;
                 }
              })
            }
         })
      });
     }else{
        if(item.Rule && item.Rule.IsRequired)
        {
          reuslt=true;
        }
     }
     return reuslt;
    }catch(e)
    {
       return false;
    }
  }

  setStock = (item, val) => {
    if (val) {
      const match = /^\d+$/.test(val)
      if (!match)
        val = item.AmountOnSale
    }
    item.AmountOnSale = val
    this.setState({})
  }
  setSkuClassType = (item, val) => {
    item.SkuClassificationType = val;
    this.setState({ })
  }
  batchSetStock = () => {
    var batchSetStockRadio = $('input[name=batchSetStockRadio]:checked').val();
    var filterZeroStockChecked = $('#batchSetStockZeroCheckbox').prop('checked');
    if (batchSetStockRadio == 'unifiedStock') {
      let stockStr = $('#unifiedStock').val();
      let stock = parseInt(stockStr);
      if (stock >= 0) {
        this.state.skuList.forEach(x => { 
          var update=true;
          if(filterZeroStockChecked&&x.AmountOnSale==0)
          {
            update=false;
          }
          if(update)
          {
            x.AmountOnSale = stock;
          }
        })
      }
    } else if (batchSetStockRadio == 'addStock') {
      let stock = parseInt($('#addStock').val());
      if (stock > 0) {
        this.state.skuList.forEach(x => {
          x.AmountOnSale = x.AmountOnSale || 0
          if (x.AmountOnSale > 0 || !filterZeroStockChecked) {
            x.AmountOnSale += stock
          }
        })
      }
    } else if (batchSetStockRadio == 'reduceStock') {
      let stock = parseInt($('#reduceStock').val());
      let minStock = parseInt($('#reduceStockLimit').val());
      minStock = minStock || 0;
      if (stock > 0) {
        this.state.skuList.forEach(x => {
          x.AmountOnSale = x.AmountOnSale || 0
          if (x.AmountOnSale > 0 || !filterZeroStockChecked) {
            x.AmountOnSale = x.AmountOnSale - stock < minStock ? minStock : x.AmountOnSale - stock;
          }
        })
      }
    }
    else if (batchSetStockRadio == 'sameStock') {
      this.state.skuList.forEach(x => {
        var update=true;
        if(filterZeroStockChecked&&x.AmountOnSale==0)
        {
          update=false;
        }
        if(update)
        {
          x.AmountOnSale = x.SourceAmountOnSale || x.AmountOnSale;
        }
      })
    }
    this.cancelModule("batchSetStockDailog")
  }
  batchSetSkuClassType = (val) => {
    this.state.skuList.forEach(sku => {
      sku.SkuClassificationType = val
    })
    this.setState({})
  }





  loadDataByRelationCode = (relationCode) => {
    this.setState({ isLoading: true });
    var that = this;

    var data = {
      relationCode: relationCode,
    };

    var that = this;
    requests({
      url: "/BatchDistribution/GetUserPreviewProductInfoByRelationCode",
      data: data,
      success: function (res) {
        that.setState({ isLoading: false });
        if (res.RequestError == true) {//请求失效了。isLoading关闭看需求写
          return;
        }

        if (res.Success) {
          var productEditDataList = res.Data.ProductEditDataList;

          if (productEditDataList.length > 0) {
            var product = productEditDataList[0];
            if(that.state.supplierProduct.Title)
            {
              product.Title = that.state.supplierProduct.Title
            }
            that.initSkuList(product.SalesProps, product.Skus)
            that.setState({
              supplierProduct: product,
              catePathList: product.CatePathList,
              catePropsList: product.CateProps,
              salesPropList: product.SalesProps,
              skuList: product.Skus,
              RelationCode:relationCode,
            },()=>{
              that.checkeSaleProps(that.state.salesPropList)
              that.checkTitle(product,false)
            });
          }
          else
            messageShow("未获取到数据，请关闭弹窗后重试！",'error');
        } else {
          that.setState({ isLoading: false });
          messageShow("获取货源数据错误：" + res.Message,'error');
        }
      },
    });
  }

  //切换导航
  changeNav = (item) => {
    this.setState({ indexs: item.id })
    // setTimeout(() => {
    //     this.queryButton(true);
    // }, 300);
  }
  changeNavIndex(index){
    const statusNav = this.state.distributionStatus.find(x => x.id == index);
    if(statusNav){
      this.state.distributionStatus.forEach(x => x.active = false)
      statusNav.active = true
      this.setState({ indexs: index})
    }
  }


  saveProductEdit = (isPh) => {
    const editModel = this.state.supplierProduct;
    var titles = this.state.supplierProduct.Title;
    var catePropsList = this.state.catePropsList;
    var salesPropList = this.state.salesPropList;
    var skuList = this.state.skuList;
    var platformRecommendId=this.state.platformRecommendId;
    var catePathList = this.state.catePathList;
    
    var isCateProps= this.checkCateProps(catePropsList);//校验属性的
    if(isCateProps == false)
      return;
    

    var catePropsListNew = [];
    catePropsList.forEach(t => {
      catePropsListNew.push({
        FieldType: t.FieldType,
        Name: t.Name,
        Value: t.Value
      });
    })
    this.checkTitle(editModel);
    if(editModel.titleError == true){
      this.changeNavIndex(0)
      this.setState({})
      return;
    }
    if (!catePathList || catePathList.length == 0) {
      this.changeNavIndex(0)
      messageShow('请选择类目','info')
      return;
    }
    const errorList = this.checkeSaleProps(salesPropList);
    // const errorList =[]
    if(errorList.length > 0){
      this.changeNavIndex(1)
      // if(errorList.length == 1)
      //   messageShow(errorList.join(';'),'error')
      // else
        messageShow('请按照规则填写正确的值','error')
      return;
    }

    const ImageInfo = {
        ProductImages: this.state.productImages,
        ProductDetailImages: this.state.productDetailImages,
        ProductThreeAndFourImages: this.state.productThreeAndFourImages,
        WhiteBackgroundImages: this.state.whiteBackgroundImages,
    }

    if(this.state.targetPlatformType=="KuaiShou") {
        if(this.state.productImages.length == 0) {
            this.changeNavIndex(2)
            messageShow('请上传商品主图','error')
            return;
        } else if (this.state.productDetailImages.length == 0) {
            this.changeNavIndex(2)
            messageShow('请上传商品详情图片','error')
            return;
        } else if (this.state.isMustProductThreeAndFourImages && this.state.productThreeAndFourImages.length == 0) {
            this.changeNavIndex(2)
            messageShow('请上传商品3:4主图','error')
            return;
        }
    }


    var salesPropNew = [];
    salesPropList.forEach((x,attrIndex) => {
      if (x.FieldType == 'measure_templates') {
        x.measure_info.map(measure_info => {
          var skuValue = measure_info.values.map(v => {
            let prefix = v.prefix || ''
            let value = v.value
            let suffix = v.suffix || ''
            let unit_name = v.unit_name || ''
            return prefix + value + unit_name + suffix;
          }).join('')

          var newskuValue = measure_info.values.map(v => {
            let prefix = v.prefix || ''
            let value = v.value
            let suffix = v.suffix || ''
            let unit_name = v.unit_name || ''
            return prefix + value + unit_name + suffix;
          }).join(' ')
          x.Value = newskuValue;
          this.state.skuList.forEach(x => {
            if (x.AttributesList[attrIndex]  == skuValue) {
              x.AttributesList[attrIndex] = newskuValue
            }
          });
          
        })
      }
    })
    
    salesPropList.forEach(t => {
      salesPropNew.push({
         Name: t.Name,
         Value: t.Value,
         measure_info:t.measure_info,
      });
    })

    this.props.saveProductEdit(titles, catePropsListNew, salesPropNew, skuList, isPh, catePathList, ImageInfo,platformRecommendId);
  }
  checkeSaleProps(salesPropList){
    const errorList = []

    for (let attrIndex = 0; attrIndex < salesPropList.length; attrIndex++) {
      const x = salesPropList[attrIndex];
      if (x.FieldType == 'measure_templates') {
        var template = x.measure_templates[0] || { };
        var value_modules = template.value_modules || [];
        var measure_info_values = x.measure_info.flatMap(item => item.values);

        for (let index = 0; index < measure_info_values.length; index++) {
          const measure_info_value = measure_info_values[index];
          var module = value_modules.find(tempModule => tempModule.module_id == measure_info_value.module_id)
          if(module){
            const errorMsg = this.checkeSalePropItem(module,measure_info_value)
            if(errorMsg){
              errorList.push('规格【'+x.Name + '】: 【'+measure_info_value.value+'】填写有误，'+errorMsg)
              continue;
            }
          }
          
        }
      }
    }

    return errorList
  }
  checkeSalePropItem(module,measure_info_value){
    if(module){
      var errorMsg = '';
      
      if(!measure_info_value.value){
        errorMsg = '请填写值'
        measure_info_value.errorMsg = errorMsg
        return errorMsg;
      }
      if (module.validate_rule) {
        if (module.validate_rule.data_type == 'float' && module.validate_rule.precision > 0){
          const reg = new RegExp('^\\d+(\\.\\d{0,'+module.validate_rule.precision+'})?$')
          let match= reg.test(measure_info_value.value)
          if (!match) {
            errorMsg = '请输入数字或小数部分不能超过'+module.validate_rule.precision+'位'
            measure_info_value.errorMsg = errorMsg
            return errorMsg;
          };
        }
        else if (module.validate_rule.data_type == 'float' 
          || module.validate_rule.data_type == 'int' 
          || module.validate_rule.data_type == 'integer') {
          const reg = new RegExp('^\\d+$')
          let match = reg.test(measure_info_value.value)
          if (!match) {
            errorMsg = '请输入数字'
            measure_info_value.errorMsg = errorMsg
            return errorMsg;
          };
        }
      }
    }
  }

  //通用值
  changeCateProps = debounceOther((item, val) => {
    item.Value = val;
    this.setState({})
  })

  //MeasureTemplates.LeftValue 的保存
  changeCatePropsBymeasure = debounceOther((item, val) => {
    item.MeasureTemplates.LeftValue = val;
    var rightOption= item.MeasureTemplates.RightOptions.find(x => x.IsSelect ==true);
    if(rightOption)
        item.Value = val+rightOption.Value;
    else 
        item.Value = val;

    this.setState({})
  })

  //MeasureTemplates.MultiValueMeasureList.Value 的保存
  changeCatePropsByMultiValueMeasure= debounceOther((item, val,index) => {
    
    item.MeasureTemplates.MultiValueMeasureList.forEach(o => {
      if(o.Index == index)
        o.Value=val;
    });
    this.setMultiValueMeasureValue(item);//整合item.Value
    this.setState({})
  })

  setMultiValueMeasureValue=(item)=>{
    var values="";
    item.MeasureTemplates.MultiValueMeasureList.forEach(o => {
      values+=o.Name+","+o.Value+"||"
    });
    item.Value=values;
  }
  

  changeSelectCateProps = debounceOther((item, val,opItem) => {
    item.Value = val;
    if(opItem && opItem.item && opItem.item.Key){
      item.ValueId = opItem.item.Key;
    }
    this.setState({})
  },100)


  changeSelectCatePropsByMeasure = debounceOther((item, val,opItem) => {
    //item.Value = val;
    item.MeasureTemplates.RightOptions.forEach(o => {
      if(o.Value ==val)
        o.IsSelect=true;
      else
        o.IsSelect=false;
    });

    item.Value = item.MeasureTemplates.LeftValue +  val;

    this.setState({})
  },100)

  //抖音-多度量衡，选择属性
  changeSelectCatePropsByMultiValueMeasure= debounceOther((item, val,index) => {
    //item.Value = val;
    item.MeasureTemplates.MultiValueMeasureList.forEach(o => {
      if(o.Index ==index)
         o.Name=val;
    });
    this.setMultiValueMeasureValue(item);//整合item.Value
    this.setState({})
  },100)

  //抖音-时间区间，选择时间后赋值
  changeDateTimeByDateTimeRange =(item,dateLeft,dateRight)=>{

    if(isNotNull(dateLeft)){
      let _date = dayjs(dateLeft);
      var  _daterangepickerValue =`${_date.$y}-${_date.$M + 1}-${_date.$D}`;
      item.MeasureTemplates.LeftValue=_daterangepickerValue;
    }
     if(isNotNull(dateRight)){
      let _date = dayjs(dateRight);
      var  _daterangepickerValue =`${_date.$y}-${_date.$M + 1}-${_date.$D}`;
      item.MeasureTemplates.RightValue=_daterangepickerValue;
    }

    if(isNotNull(item.MeasureTemplates.LeftValue))
      item.Value=item.MeasureTemplates.LeftValue;
    

    if(isNotNull(item.MeasureTemplates.RightValue))
    {
      if(isNotNull(item.MeasureTemplates.LeftValue))
        item.Value+=",";

      item.Value+=item.MeasureTemplates.RightValue;
    }
    console.log('DateRangePicker1 item.Value: ', item.Value)
    this.setState({})
  } 
  

  //多度量衡，添加标签
  addMultiValueMeasure=(item)=>{
    var list= item.MeasureTemplates.MultiValueMeasureList;
    var index=list[list.length -1].Index+1;
    list.push({
       Index:index,
       Name:"",
       Value:100
    });
    this.setState({})
  }
  reduceMultiValueMeasure=(item,index)=>{
    var list= item.MeasureTemplates.MultiValueMeasureList;
    list.splice(index,1);
    this.setState({})
  }
  
  

  brandSearch = debounceOther(async (item,key) =>{
    if(!key) {
      item.Options =[];
      this.setState({ })
      return;
    }

    const data = {};
    data.CateId = this.state.catePathList[this.state.catePathList.length - 1].CateId;
    data.TargetShopId = this.state.targetShopId;
    data.targetPlatformType = this.state.targetPlatformType;
    data.QueryKey = key;
    this.setState({ isLoading : true})
    const res = await GetCategoryBrandsRequest(data);
    this.setState({ isLoading : false})
    if(res.Success){
      item.Options = (res.Data.Brands && res.Data.Brands.map(ele => { return ele.Value })) || [];
      this.setState({ })
    }
  },1000)




  queryProduct = () => {
    const item = this.state.sourceSupplierProduct
    huoyuanLink(item)
  }

  closeModule = () => {
    if (typeof this.props.cancelDailog == "function") {
      this.props.cancelDailog();
    }
  }

  cancelModule = (typeName) => {
    this.setState({ [typeName]: false });

  }
  showBatchSetDailog = (typeName) => {
    this.setState({ [typeName]: true });

  }

  getSelectOb = (obj) => {

  }

  //确认销售属性
  confirmAddSaleProp(item) {
    item.isAddSaleProp = true
    this.setState({});
  }
  closeAddSaleProp(item) {
    item.isAddSaleProp = false
    this.setState({});
  }
  //添加销售属性
  addSaleProp(val, list, item, ele) {
    if (!val) {
      val = $(ele).prev().val();
    }
    if (!val) {
      messageShow('请输入规格值','info')
      return;
    }

    const exists = list.includes(val);
    if (exists) {
      messageShow('已存在','info')
      return;
    }

    this.addSaleInit(val,list,item)
    item.isAddSaleProp = false
    this.initSkuList(this.state.salesPropList, this.state.skuList)

    this.setState({})
  }
  addSaleInit(val,list,saleItem){
    list.push(val);
    if(!saleItem.TempValues) saleItem.TempValues = []
    saleItem.TempValues.push({
      val:val,
      id:new Date().valueOf() + val
    })
  }
  //更新销售属性
  updateSaleProp = debounceOther((item, val, oldVal) => {
    const exists = item.Value.includes(val);
    if (exists) {
      messageShow('规格值已存在','info')
      return;
    }
    const index = item.Value.findIndex(x => x == oldVal)
    if (index > -1) {
      item.Value[index] = val
      item.TempValues[index].val = val
      this.state.skuList.forEach(x => {
        var attrIndex = x.AttributesList.findIndex(o => o == oldVal);
        if (attrIndex > -1) {
          x.AttributesList[attrIndex] = val
        }
      });
      this.initSkuList(this.state.salesPropList, this.state.skuList);
      this.setState({})

    }
  })

  addMeasureSaleProp(ele,item,template){
    var valueEles = $(ele).parent().children('.saleModuleItem');

    var values =[]
    for (let index = 0; index < valueEles.length; index++) {
      const element = valueEles[index];
      const data = $(element).data();
      const module = template.value_modules.find(x => x.module_id == data.module_id);
      
      if(module){
        const input = $(element).children('span').children('input');
        const select = $(element).children('span').children('select');
        var currentVal = $(input).val();
        var unit_name = $(select).val();
        var hasUtis = !module.units && module.units.length > 0;

        var errorMsg = '';
        if(hasUtis && unit_name){
          //请选择
          errorMsg = '请选择单位'
        }
        if(!currentVal){
          errorMsg = '请填写值'
        }
        if (module.validate_rule) {
          if (module.validate_rule.data_type == 'float') {
            let match = /^\d+\.{0,1}\d{0,1}$/.test(currentVal)
            if (!match) {
              errorMsg = '请输入数字'
            };
          } else if (module.validate_rule.data_type == 'int' || module.validate_rule.data_type == 'integer') {
            let match = /^\d$/.test(currentVal)
            if (!match) {
              errorMsg = '请输入数字'
            };
          }
        }
        if(errorMsg){
          module.isError = true
          module.errorMsg = errorMsg
        }else{
          module.isError = false
          values.push({
            module_id:module.module_id,
            prefix:module.prefix,
            value:currentVal,
            suffix:module.suffix,
            unit_name:unit_name,
          })
        }

      }
    }
    var errorItems = template.value_modules.filter(x => x.isError == true);
    if(errorItems.length > 0){
      messageShow(errorItems[0].errorMsg,'info')
      return;
    }
    const measureInfoItemValue = {
      template_id:template.template_id,
      values:values,
    }
    var newValue = measureInfoItemValue.values.map(v => {
      let prefix = v.prefix || ''
      let value = v.value
      let suffix = v.suffix || ''
      let unit_name = v.unit_name || ''
      return prefix + value + unit_name + suffix;
    }).join('')
    const exists = item.Value.includes(newValue)
    if (exists) {
      messageShow('规格值已存在','info')
      return;
    }
    // item.Value.push(newValue)
    this.addSaleInit(newValue,item.Value,item)
    item.measure_info.push(measureInfoItemValue)
    item.isAddSaleProp = false;
    template.value_modules.forEach(item =>{ item.addTemp = null});
    // console.log('item.measure_info =>',item.measure_info);
    this.initSkuList(this.state.salesPropList, this.state.skuList)
    
  }
  updateMeasureSaleProp = debounceOther((item, module, currentVal, oldItem, measure_info,index) => {
    if(item.Value.length <= index){
      return
    }
    var oldValue = item.Value[index]

    var oldItemValue = oldItem.value;
    oldItem.value = currentVal;
    var newValue = measure_info.values.map(v => {
      let prefix = v.prefix || ''
      let value = v.value
      let suffix = v.suffix || ''
      let unit_name = v.unit_name || ''
      return prefix + value + unit_name  + suffix;
    }).join('')
    
    const hasError = this.checkeSalePropItem(module,oldItem)
    oldItem.value = oldItemValue;
    let errorMsg = oldItem.errorMsg
    if (hasError) {
      oldItem.errorMsg = errorMsg
      messageShow(errorMsg,'error')
    }else{
      oldItem.errorMsg = null
    }

    if (oldItemValue == newValue) {
      return;
    }
    const exists = item.Value.includes(newValue)
    if (exists) {
      messageShow('规格值已存在','info')
      return;
    }

    if (index > -1) {
      item.Value[index] = newValue
      item.TempValues[index].val = newValue
      oldItem.value = currentVal;
      this.state.skuList.forEach(x => {
        var attrIndex = x.AttributesList.findIndex(o => o == oldValue);
        if (attrIndex > -1) {
          x.AttributesList[attrIndex] = newValue
        }
      });
      if (measure_info.values.filter(v => v.errorMsg).length > 0) {
        this.setState({})
        return
      }

      this.initSkuList(this.state.salesPropList, this.state.skuList);
      this.setState({})
    }
  })
  addSelectMeasureSaleProp = (item, module, currentVal)=>{
    var id='#add_module_' + module.module_id + '_'+item.Name;
    $(id).val(currentVal);
    module.addTemp = module.addTemp || {};
    module.addTemp.val = currentVal;
  }
  updateMeasureSalePropPrevCheck = (item, module, currentVal, oldItem, measure_info,index) => {
    if(item.Value.length <= index){
      return false
    }
    

    var oldItemValue = oldItem.value;
    oldItem.value = currentVal;
    var newValue = measure_info.values.map(v => {
      let prefix = v.prefix || ''
      let value = v.value
      let suffix = v.suffix || ''
      let unit_name = v.unit_name || ''
      return prefix + value + unit_name + suffix;
    }).join('')

    oldItem.value = oldItemValue;
    if (oldItemValue == newValue) {
      return false;
    }
    const exists = item.Value.includes(newValue)
    if (exists) {
      messageShow('规格值已存在','info')
      return false;
    }

    return true
  }
  updateSalePropCheck(item, val, oldVal) {
    const exists = item.Value.includes(val);
    if (exists) {
      messageShow('规格值已存在','info')
      return false;
    }
    return true;
  }
  deleteSaleProp(item, index, measure_info) {
    
    if (item.Value.length <= 1) {
      messageShow('最少保留一个规格','info')
      return;
    }
    if(index > -1 && index <= item.Value.length -1)
    {
      item.Value.splice(index,1)
      item.TempValues.splice(index,1)
      if(measure_info){
        const measureIndex = item.measure_info.indexOf(measure_info);
        if(measureIndex > -1){
          item.measure_info.splice(measureIndex, 1);
        }
      }
      this.initSkuList(this.state.salesPropList, this.state.skuList);
    }
  }

  initSkuList(saleProps, skuList) {
    for (let index = 0; index < saleProps.length; index++) {
      const element = saleProps[index];
      if(!element.TempValues){
        element.TempValues = []
        for (let j = 0; j < element.Value.length; j++) {
          const val = element.Value[j];
          element.TempValues.push({
            val : val,id : new Date().valueOf()+val
          })
        }
        
      }
      if(element.measure_info){
        for (let j = 0; j < element.measure_info.length; j++) {
          const measure_info = element.measure_info[j];
          if(!measure_info.id)
            measure_info.id = element.TempValues[j].id;
        }
      }
    }
    var salePropsTemp= saleProps.map(x => x.Value);
    let allSkus = salePropsTemp.reduce((prev, cur, currentIndex) => {
      if (!Array.isArray(prev) || !Array.isArray(cur)) {
        return
      }
      if (currentIndex == 0) {
        return cur.map(x => [x]);
      }
      const empty = [];
      prev.forEach(val => {
        cur.forEach((item, index) => {
          var arr = [...val]
          arr.push(item)
          empty.push(arr)
        })
      })
      return empty
    }, [])

    const sourceSku = {};
    skuList.forEach(element => {
      sourceSku[element.AttributesList.join('_')] = element;
    });
    const newSkus = []
    if (salePropsTemp.filter(x => x.length == 0).length == 0) {
      for (let index = 0; index < allSkus.length; index++) {
        const sku = allSkus[index];
        const skukey = sku.join('_');
        var item = sourceSku[skukey];
        if (item) {
          newSkus.push(item)
        } else {
          newSkus.push({ AttributesList: sku })
        }
      }
    }

    this.state.skuList = newSkus
  }
  getStrByteCnt(str) {
    if (!str) return 0;
    return str.replace(/[\u0391-\uFFE5]/g, "aa").length
  }

  //输入框
  inputSaleRender(item) {
    if (item.FieldType != 'input') return null
    var eles = item.TempValues.map((val,index) => {
      if(index==0)
      {
        return <label style={{ marginRight: 5 }} key={val.id}>
        <input type="text" defaultValue={val.val} onChange={(e) => { this.updateSaleProp(item, e.target.value, val.val) }} />
      </label>
      }else{
        return <label style={{ marginRight: 5 }} key={val.id}>
        <input type="text" defaultValue={val.val} onChange={(e) => { this.updateSaleProp(item, e.target.value, val.val) }} />
        <span className='iconfont icon-laji dangerColor hover' onClick={() => { this.deleteSaleProp(item, index) }}></span>
      </label>
      }
     
    })
    if (item.isAddSaleProp)
      eles.push(<label style={{ marginRight: 5 }}>
        <input type="text" id='addSalePropInput' />
        <span className='listing-sureBtn' onClick={(e) => { this.addSaleProp(null, item.Value, item, e.target) }}>确定</span>
        <span className='listing-infoBtn'  onClick={() => { this.closeAddSaleProp(item) }}>取消</span>
      </label>)
    return eles
  }
  //下拉
  singleCheckSaleRender(item) {
    if (item.FieldType != 'singleCheck') return null
    var eles = item.Value.map((val,index) => {
      if(index==0)
      {
      return <label style={{ marginRight: 5 }}>
        <SelectBox
          selectData={item.Options.map(x => { return { title: x } })}
          selectTitle={val}
          onchange={(selectItem) => { this.updateSaleProp(item, selectItem.selectObj.title, val) }}
          onchangecheck={(selectItem) => { return this.updateSalePropCheck(item, selectItem.selectObj.title, val) }}
        >
        </SelectBox>
      </label>
      }else{
        return <label style={{ marginRight: 5 }}>
        <SelectBox
          selectData={item.Options.map(x => { return { title: x } })}
          selectTitle={val}
          onchange={(selectItem) => { this.updateSaleProp(item, selectItem.selectObj.title, val) }}
          onchangecheck={(selectItem) => { return this.updateSalePropCheck(item, selectItem.selectObj.title, val) }}
        >
        </SelectBox>
        <span className='iconfont icon-laji dangerColor hover' onClick={() => { this.deleteSaleProp(item, index) }}></span>
      </label>
      }
    })
    if (item.isAddSaleProp) {
      eles.push(<label style={{ marginRight: 5 }}>
        <SelectBox
          selectData={item.Options.map(x => { return { title: x } })}
          onchange={(selectItem) => { this.addSaleProp(selectItem.selectObj.title, item.Value, item) }}
        >
        </SelectBox>
        <span className='listing-infoBtn'  onClick={() => { this.closeAddSaleProp(item) }}>取消</span>
      </label>)
    }
    return eles
  }

 
  measure_templatesSaleRender(item) {


    if (item.FieldType != 'measure_templates') return null
    const template = item.measure_templates[0]
    var eles = item.measure_info.map((measure_info,index) => {
      const values = measure_info.values

      var eleItem = values.map((val) => {
        var module = template.value_modules.find(x => x.module_id == val.module_id);


        return <label className='saleModuleItem' key={module.module_id} >
          {val.prefix ? <span>{val.prefix}</span> : null}
          {
            module && (module.input_type == 'input' || module.input_type == 'enum_diy') ?
              <span>
                {
                  module.validate_rule && module.validate_rule.data_type == 'string'?
                  <input type="text" className={(val.errorMsg ? 'error' : '')} style={{width:'120px'}} defaultValue={val.value} key={module.module_id}  onChange={(e) => { this.updateMeasureSaleProp(item, module, e.target.value, val, measure_info,index) }} />
                  :<input type="text" className={(val.errorMsg ? 'error' : '')} defaultValue={val.value} key={module.module_id}  onChange={(e) => { this.updateMeasureSaleProp(item, module, e.target.value, val, measure_info,index) }} />
                }
                
                {
                  module.units && module.units.length > 0 ? 
                  <select name="" className='utis_select' value={val.unit_name} onChange={(e)=>{ this.updateUnit(item, module, e.target.value, val, measure_info,index)}}>
                    {
                      module.units.map(x => {
                        return <option value={x.unit_name}>{x.unit_name}</option>
                      })
                    }
                  </select>:null
                }
                </span> : module.input_type == 'enum'?
                <span className='saleModuleItem_enum'>
                   <SelectBox
                      width={'70'}
                      height={'32'}
                      selectData={module.values.map(x => { return { title: x } })}
                      selectTitle={val.value}
                      onchange={(selectItem) => { this.updateMeasureSaleProp(item, module,  selectItem.selectObj.title, val, measure_info,index) }}
                      onchangecheck={(selectItem) => { return this.updateMeasureSalePropPrevCheck(item, module,  selectItem.selectObj.title, val, measure_info,index) }}
                    >
                    </SelectBox>
                  {
                    module.units && module.units.length > 0 ? 
                    <select name="" className='utis_select' value={val.unit_name} onChange={(e)=>{ this.updateUnit(item, module, e.target.value, val, measure_info,index)}}>
                      {
                        module.units.map(x => {
                          return <option value={x.unit_name}>{x.unit_name}</option>
                        })
                      }
                    </select>:null
                  }
                </span>:null
          }
          {val.suffix ? <span>{val.suffix}</span> : null}
        </label>
      })


      return <label className='saleItem saleMeasureItem addWrape-listing' style={{ marginRight: 10 }} key={measure_info.id}>
        {eleItem}
        <span className='iconfont icon-laji dangerColor hover' onClick={() => { this.deleteSaleProp(item, index, measure_info) }}></span>
      </label>
    })


    if (item.isAddSaleProp)
      eles.push(<label className='saleItem saleMeasureItem addWrape-listing' style={{ marginRight: 10 }}>
        {
          template.value_modules.map(module => {
            var addTemp = module.addTemp || {};
            return <label className='saleModuleItem' data-module_id={module.module_id}>
              {module.prefix ? <span>{module.prefix}</span> : null}
              {
                module && (module.input_type == 'input' || module.input_type == 'enum_diy') ?
                  <span>
                    <input type="text" />
                    {
                      module.units && module.units.length > 0 ? 
                      <select name="" className='utis_select'>
                        {
                          module.units.map(x => {
                            return <option value={x.unit_name}>{x.unit_name}</option>
                          })
                        }
                      </select>:null
                    }
                  </span> : module.input_type == 'enum'?
                  <span className='saleModuleItem_enum'>
                    <input type='hidden' id={'add_module_' +module.module_id+'_'+item.Name}/>
                    <SelectBox
                        width={'70'}
                        height={'32'}
                        selectTitle={addTemp.val}
                        selectData={module.values.map(x => { return { title: x } })}
                        onchange={(selectItem) => { this.addSelectMeasureSaleProp(item, module,  selectItem.selectObj.title) }}
                      >
                    </SelectBox>
                    {
                      module.units && module.units.length > 0 ? 
                      <select name="" className='utis_select'>
                        {
                          module.units.map(x => {
                            return <option value={x.unit_name}>{x.unit_name}</option>
                          })
                        }
                      </select>:null
                    }
                  </span>: null
              }
              {module.suffix ? <span>{module.suffix}</span> : null}
            </label>
          })
        }

        <span className='listing-sureBtn' onClick={(e) => { this.addMeasureSaleProp(e.target,item,template) }}>确定</span>
        <span className='listing-infoBtn' onClick={() => { this.closeAddSaleProp(item) }}>取消</span>

      </label>)

    return eles;
  }
  measure_templatesSaleExampleRender(item) {
    if (item.FieldType != 'measure_templates') return null
    const template = item.measure_templates[0]
    
    let eles = []
    if(template.value_modules){
      const value_modules = []
      for(module of template.value_modules){
        if(module.prefix){
          value_modules.push(<span>{ ' ' + module.prefix + ' '}</span>)
        }
        if(module.validate_rule && module.validate_rule.data_type == 'integer'){
          value_modules.push(<span>数字</span>)
        }else if(module.validate_rule && module.validate_rule.data_type == 'float'){
          value_modules.push(<span>数字</span>)
        }else{
          value_modules.push(<span>文本内容（规格描述） </span>)
        }
        if(module.units && module.units.length > 0){
          value_modules.push(<span>+单位</span>)
        }
        if(module.suffix){
          value_modules.push(<span>{ ' ' + module.suffix + ' '}</span>)
        }
      }
      eles.push(<div>{value_modules}</div>)
    }
    return <div style={{display:'flex',color:'#fea41f'}}>
      <span>示例：</span>
      {eles}
      {/* <div><span>数字</span><span>+单位</span><span> * </span></div>
      <div><span>数字</span><span>+单位</span></div> */}
    </div>;    
  }

  hideShowSelectCategoryModule = () => {
    this.setState({
      showSelectCategoryModule: false,
    })
  }
  updateUnit(item, module, unitname, oldItem, measure_info,index){
    // item.unit_name = val;
    oldItem.unit_name= unitname
    this.updateMeasureSaleProp(item,module,oldItem.value,oldItem,measure_info,index)
  } 

  handleRecommondCateFeedback = (item) => {
    if(item.QualificationStatus === 0) {
        let strName = "";
        item.CateItems.forEach(function(cItem, cIndex) {
            strName += (cItem.Name + (item.CateItems.length - 1 > cIndex ? "—" : ""))
        });

        this.selectCategory(item.CateItems, strName);
    }
  }

    // 上传图片
    handleImageChange = (event, type) => {
    const files = Array.from(event.target.files);

    files.forEach(file => {
        if (file.size <= 2 * 1024 * 1024 && ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if(type == 0){
                    if (this.state.productImages.length === 5) { // 确保不超过5张图片
                        messageShow("最多只能上传5张图片！", 'error');
                    } else {
                        const reqData = {
                            ProductImageType : 1,
                            TargetShopId: this.state.targetShopId,
                            TargetPlatformType: this.state.targetPlatformType,
                            ImgBase64: e.target.result,
                            FileName: file.name,
                        }

                        var that = this;

                        PlatformUploadImageRequest(reqData).then(function(res) {
                            if(res.Success) {
                                that.setState({
                                    productImages: [...that.state.productImages, res.Data.PicUrl]
                                })
                            } else {
                                messageShow(res.Message, 'error');
                            }
                        })
                    }
                } else if (type == 1) {
                    if (this.state.productThreeAndFourImages.length === 5) {
                        messageShow("最多只能上传5张图片！", 'error');
                    } else {
                        const reqData = {
                            ProductImageType : 10,
                            TargetShopId: this.state.targetShopId,
                            TargetPlatformType: this.state.targetPlatformType,
                            ImgBase64: e.target.result,
                            FileName: file.name,
                        }

                        var that = this;

                        PlatformUploadImageRequest(reqData).then(function(res) {
                            if(res.Success) {
                                that.setState({
                                    productThreeAndFourImages: [...that.state.productThreeAndFourImages, res.Data.PicUrl]
                                })
                            } else {
                                messageShow(res.Message, 'error');
                            }
                        })
                    }
                } else if (type == 2) {
                    if (this.state.whiteBackgroundImages.length === 1) {
                        messageShow("最多只能上传1张图片！", 'error');
                    } else {
                        const reqData = {
                            ProductImageType : 5,
                            TargetShopId: this.state.targetShopId,
                            TargetPlatformType: this.state.targetPlatformType,
                            ImgBase64: e.target.result,
                            FileName: file.name,
                        }

                        var that = this;

                        PlatformUploadImageRequest(reqData).then(function(res) {
                            if(res.Success){
                                that.setState({
                                    whiteBackgroundImages: [...that.state.whiteBackgroundImages, res.Data.PicUrl]
                                })
                            } else {
                                messageShow(res.Message, 'error');
                            }
                        })
                    }
                } else if (type == 3) {
                    if (this.state.productDetailImages.length === 50) {
                        messageShow("最多只能上传50张图片！", 'error');
                    } else {
                        const reqData = {
                            ProductImageType : 2,
                            TargetShopId: this.state.targetShopId,
                            TargetPlatformType: this.state.targetPlatformType,
                            ImgBase64: e.target.result,
                            FileName: file.name,
                        }

                        var that = this;

                        PlatformUploadImageRequest(reqData).then(function(res) {
                            if(res.Success) {
                                that.setState({
                                    productDetailImages: [...that.state.productDetailImages, res.Data.PicUrl]
                                })
                            } else {
                                messageShow(res.Message, 'error');
                            }
                        })
                    }
                }
            };
            reader.readAsDataURL(file);
        } else if (file.size > 2 * 1024 * 1024) {
            messageShow("仅支持上传大小为2M内的图片", 'error');
        } else if (['image/jpeg', 'image/jpg', 'image/png'].includes(file.type) === false){
            messageShow("仅支持上传格式为png/jpeg/jpg的图片", 'error');
        }
    });

    event.target.value = "";
  }

  // 移除图片
  handleImageDelete = (type, index) => {
    const removeElement = (arr, rIndex) => {
        return arr.filter((_, i) => i !== rIndex);
    };

    if(type == 0) {
        const newArray = removeElement(this.state.productImages, index);
        this.setState({
            productImages: newArray
        })
    } else if(type == 1) {
        const newArray = removeElement(this.state.productThreeAndFourImages, index);
        this.setState({
            productThreeAndFourImages: newArray
        })
    } else if(type == 2) {
        const newArray = removeElement(this.state.whiteBackgroundImages, index);
        this.setState({
            whiteBackgroundImages: newArray
        })
    } else if(type == 3) {
        const newArray = removeElement(this.state.productDetailImages, index);
        this.setState({
            productDetailImages: newArray
        })
    }
  }

  // 预览图片
  onHandleImageView = (type, index) => {
    if(type == 0) {
        this.setState({
            openImageBigModal: true,
            currentImage: this.state.productImages[index]
        })
    } else  if(type == 1) {
        this.setState({
            openImageBigModal: true,
            currentImage: this.state.productThreeAndFourImages[index]
        })
    } else  if(type == 2) {
        this.setState({
            openImageBigModal: true,
            currentImage: this.state.whiteBackgroundImages[index]
        })
    } else  if(type == 3) {
        this.setState({
            openImageBigModal: true,
            currentImage: this.state.productDetailImages[index]
        })
    }
  }

  // 关闭预览
  onCloseImageBigModal = () => {
    this.setState({
        openImageBigModal: false,
        currentImage: ""
    })
  }

  // 切换图片
  handleImageReplace= (event, type, index) => {
    const files = Array.from(event.target.files);

    const updateItemInArray = (array, uIndex, newItem) => {
        const newArray = [...array]; // 创建一个新数组的副本
        newArray.splice(uIndex, 1, newItem); // 在指定位置替换元素
        return newArray;
    };

    files.forEach(file => {
        if (file.size <= 2 * 1024 * 1024 && ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if(type == 0) {
                    const reqData = {
                        ProductImageType : 1,
                        TargetShopId: this.state.targetShopId,
                        TargetPlatformType: this.state.targetPlatformType,
                        ImgBase64: e.target.result,
                        FileName: file.name,
                    }

                    var that = this;

                    PlatformUploadImageRequest(reqData).then(function(res) {
                        if(res.Success){
                            const newArray = updateItemInArray(that.state.productImages, index, res.Data.PicUrl);
                            that.setState({
                                productImages: newArray
                            })
                        } else {
                            messageShow(res.Message, 'error');
                        }
                    })
                } else if (type == 1) {
                    const reqData = {
                        ProductImageType : 10,
                        TargetShopId: this.state.targetShopId,
                        TargetPlatformType: this.state.targetPlatformType,
                        ImgBase64: e.target.result,
                        FileName: file.name,
                    }

                    var that = this;

                    PlatformUploadImageRequest(reqData).then(function(res) {
                        if(res.Success) {
                            const newArray = updateItemInArray(that.state.productThreeAndFourImages, index, res.Data.PicUrl);
                            that.setState({
                                productThreeAndFourImages: newArray
                            })
                        } else {
                            messageShow(res.Message, 'error');
                        }
                    })
                } else if (type == 2) {
                    const reqData = {
                        ProductImageType : 5,
                        TargetShopId: this.state.targetShopId,
                        TargetPlatformType: this.state.targetPlatformType,
                        ImgBase64: e.target.result,
                        FileName: file.name,
                    }

                    var that = this;

                    PlatformUploadImageRequest(reqData).then(function(res) {
                        if(res.Success){
                            const newArray = updateItemInArray(that.state.whiteBackgroundImages, index, res.Data.PicUrl);
                            that.setState({
                                whiteBackgroundImages: newArray
                            })
                        } else {
                            messageShow(res.Message, 'error');
                        }
                    })
                } else if (type == 3) {
                    const reqData = {
                        ProductImageType : 2,
                        TargetShopId: this.state.targetShopId,
                        TargetPlatformType: this.state.targetPlatformType,
                        ImgBase64: e.target.result,
                        FileName: file.name,
                    }

                    var that = this;

                    PlatformUploadImageRequest(reqData).then(function(res) {
                        if(res.Success) {
                            const newArray = updateItemInArray(that.state.productDetailImages, index, res.Data.PicUrl);
                            that.setState({
                                productDetailImages: newArray
                            })
                        } else {
                            messageShow(res.Message, 'error');
                        }
                    })
                }
            };
            reader.readAsDataURL(file);
        } else if (file.size > 2 * 1024 * 1024) {
            messageShow("仅支持上传大小为2M内的图片", 'error');
        } else if (['image/jpeg', 'image/jpg', 'image/png'].includes(file.type) === false){
            messageShow("仅支持上传格式为png/jpeg/jpg的图片", 'error');
        }
    });

    event.target.value = "";
  }

  render() {
    const { supplierProduct } = this.state;
    return (
      <div className="listingProductEditWrap" onClick={()=>this.hideShowSelectCategoryModule()}>
        <div className="listingProductEditWrap-content">
          <div className="listingProductEditWrap-title">
            <span>编辑商品</span>
            <i className='iconfont icon-jia-copy1' onClick={() => this.closeModule()}></i>
          </div>
          {/* <div className="listingProductEditWrap-product">
            <div className="listingProductEditWrap-product-main">
              <img src="https://cbu01.alicdn.com/img/ibank/O1CN01uzCMG21m3n9Anjau3_!!2214809424899-0-cib.jpg" alt="" />
              <div className="listingProductEditWrap-product-main-title">{supplierProduct.Title}</div>
            </div>
          </div> */}

          <div className='listingProductEditWrap-nav'>
            <TableNavChange distributionStatus={this.state.targetPlatformType=="KuaiShou" ? this.state.distributionStatus : this.state.distributionStatus.slice(0,2)} noShowNum={true}  changeNav={this.changeNav} />
          </div>

          <div className="listingProductEditWrap-infoWrap">



            <div className="listingProductEditWrap-infoWrap-main">

              {
                this.state.indexs == 0 ?
                  <div>
                    <div className="listingProductEditWrap-info-title">基本信息</div>
                    <div className="listingProductEditWrap-info-content">
                      <div className="listingProductEditWrap-info-content-left">
                        <ul className="listingProductEditWrap-info-content-left-ul">
                          <li className='info-content-left-li' style={{ width: '100%' }}>
                            <span className='info-content-title'><i>*</i>商品标题</span>
                            <div className="titeInputWrap" onClick={()=>{ document.getElementById('productNameId').focus()}}>
                              <input placeholder='' id="productNameId" type="text" style={{ width: "507px",paddingRight:'65px' }} className={fromClassName({
                                'titleError':supplierProduct.titleError
                              })} value={supplierProduct.Title} onChange={(e) => { this.setTitle(supplierProduct, e.currentTarget.value) }}/>
                              <div className="titeInputWrap-rightWrap"><span>{this.getStrByteCnt(supplierProduct.Title)}</span><i>/</i><span>60</span></div>
                            </div>
                          </li>
                          <li className='info-content-left-li' style={{ width: '100%' }}>
                            <span className='info-content-title'><i>*</i>商品类目</span>

                            <div className="chooseMulu-wrap" onClick={(e)=>this.stopM(e)}>
                              <div className="chooseMulu-wrap-operate" style={{ width: '488px' }} onClick={() => this.showSelectCategoryModule()}>
                                {
                                  this.state.catePathList && this.state.catePathList.length > 0 ?
                                    <span>{this.state.catePathList.map(x => x.CateName).join("-")}</span>
                                    : <span>请选择商品类目</span>
                                }
                                <i className="iconfont icon-xiangxia"></i>
                              </div>
                              {/* {
                                this.state.selecCatetTitle ?
                                  <div className="chooseMulu-wrap-operateSuccess">
                                    <span className="chooseMulu-wrap-leftTitle">已选择：</span>
                                    <span className="chooseMulu-wrap-rightTitle">{this.state.selecCatetTitle}</span>
                                  </div> : null
                              } */}
                              <SelectCategoryModule
                                showSelectCategoryModule={this.state.showSelectCategoryModule}
                                targetPlatformType={this.state.targetPlatformType}
                                targetShopId={this.state.targetShopId}
                                selectCategory={this.selectCategory}
                              />
                            </div>


                          </li>
                            {
                            this.state.recommondCateList && this.state.recommondCateList.length > 0 ?
                            <li className='info-content-left-li' style={{ width: '100%', marginBottom: '7px' }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ color: '#b7b7b7', whiteSpace: 'nowrap' }}>平台推荐类目：</div>
                                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginLeft: '-12px' }}>
                                    {
                                    this.state.recommondCateList.map((item, index) => {
                                        return <div className='info-content-left-li_tag popoverCommon' key={index}>
                                        <span onClick={() => {this.handleRecommondCateFeedback(item)}} style={{ color: item.QualificationStatus === 0 ? '#333' : '#b7b7b7' }}>
                                        {

                                            item.strLength > 8 ? item.CateItems[0].Name + ' - ' + '...' + ' - ' + item.CateItems[item.CateItems.length-1].Name : 
                                            item.CateItems.map((cItem, cIndex) => {
                                                return <span key={cItem.Id}>{cItem.Name + (item.CateItems.length - 1 > cIndex ? ' - ' : '')}</span>
                                            })
                                        }
                                        </span>
                                        <div className='popoverCommon-warn' style={{ bottom: '32px', color: '#000', left: '0px', fontSize: '12px', width: item.QualificationStatus === 1 ? '304px' : item.QualificationStatus === 2 ? "280px" : "250px" }}>
                                            <div>
                                                {
                                                    item.CateItems.map((cItem, cIndex) => {
                                                        return <span key={cItem.Id}>{cItem.Name + (item.CateItems.length - 1 > cIndex ? ' - ' : '')}</span>
                                                    })
                                                }
                                            </div>
                                                {
                                                    item.QualificationStatus === 1 ? <div>当前类目资质已过期，如需使用该类目，请重新申请资质</div> : null
                                                }
                                                {
                                                    item.QualificationStatus === 2 ? <div>当前类目未开通，如需使用该类目，请申请类目资质</div> : null
                                                }
                                                {
                                                     item.QualificationStatus === 1 || item.QualificationStatus === 2 ? <a style={{ color: '#17aef1' }} href='https://fxg.jinritemai.com/ffa/gov/qualification/industry-edit' target="_blank">{'立即申请>'}</a> : null
                                                }
                                         </div>
                                    </div>
                                    })
                                }
                            </div>
                        </div>
                            </li> : null
                            }


                          {/* <li className='info-content-left-li'>
                        <span className='info-content-title'><i>*</i>品牌</span>
                        <Select
                          showSearch
                          placeholder="搜索品牌"
                          dataSource={[]}
                          // defaultValue={item.selectData.Value}
                          // onSearch={this.handleSearch}
                          style={{ width: 400 }}
                          onChange={(e) => this.onChangeForm(e, item)}
                        />
                      </li> */}


                          {/* 属性循环显示 */}
                          {
                            this.state.catePropsList.map((item) =>
                              item.FieldType == 'brandSearch' ? 
                                <li className='info-content-left-li'>
                                  <span className='info-content-title'>
                                   {
                                          this.checkPropIsMust(item)?<i>*</i> : null
                                    }
                                    {item.Name}
                                  </span>
                                  <SelectBox
                                    selectData={item.Options.map(x => { return { title: x } })}
                                    selectTitle={item.Value}
                                    searchKeyword={(keyword) => { this.brandSearch(item,keyword) }}
                                    onchange={(selectItem) => { this.changeSelectCateProps(item, selectItem.selectObj.title,selectItem.selectObj) }}
                                  >
                                  </SelectBox>
                                </li>:
                              item.FieldType == "input" ?
                                <li className='info-content-left-li'>
                                  <span className='info-content-title'>
                                    {
                                          this.checkPropIsMust(item)?<i>*</i> : null
                                    }
                                    {item.Name}
                                  </span>
                                  <input type="text" defaultValue={item.Value} onChange={(e) => { this.changeCateProps(item, e.target.value) }} />
                                </li>
                                : item.FieldType == "singleCheck" ?
                                  <li className='info-content-left-li'>
                                    <span className='info-content-title'>
                                       {
                                          this.checkPropIsMust(item)?<i>*</i> : null
                                        }
                                      {item.Name}
                                    </span>
                                    <SelectBox
                                      selectData={item.Options.map(x => { return { title: x } })}
                                      selectTitle={item.Value}
                                      onchange={(selectItem) => { this.changeSelectCateProps(item, selectItem.selectObj.title) }}
                                    >
                                    </SelectBox>
                                  </li>
                                  : item.FieldType == "measure" ?
                                      <li className='info-content-left-li flex'>
                                       <span className='info-content-title'>
                                        {
                                          this.checkPropIsMust(item)?<i>*</i> : null
                                        }
                                        {item.Name}
                                      </span>
                                      <input type="text" style={{width:'150px',marginRight: '4px'}} defaultValue={item.MeasureTemplates.LeftValue} onChange={(e) => { this.changeCatePropsBymeasure(item, e.target.value) }} />
                                      <SelectBox
                                        style={{height:'26px'}}
                                        selectData={item.MeasureTemplates.RightOptions.map(x => { return { title: x.Value,isSelect:x.IsSelect } })}
                                        onchange={(selectItem) => { this.changeSelectCatePropsByMeasure(item, selectItem.selectObj.title) }}
                                      >
                                      </SelectBox>
                                    </li>
                                    : item.FieldType == "dateTime" ?
                                      <li className='info-content-left-li'>
                                       <span className='info-content-title'>
                                        {
                                          this.checkPropIsMust(item)?<i>*</i> : null
                                        }
                                        {item.Name}
                                      </span>
                                      <DatePicker
                                      value={  item.Value==""?"":new Date(item.Value)}
                                      placeholder="选择日期"
                                      format="yyyy-MM-dd"
                                      onChange={date=>{
                                           if(date!=null)
                                           {
                                             let _date = dayjs(date);
                                             var _daterangepickerValue =`${_date.$y}-${_date.$M + 1}-${_date.$D}`;
                                             item.Value=_daterangepickerValue;
                                             this.setState();
                                           }else{
                                             item.Value='';
                                             this.setState();
                                           }
                                      }}
                                      />

                                     </li>
                                    : item.FieldType == "dateTimeRange" ?
                                      <li className='info-content-left-li' style={{width: '100%'}}>
                                        <span className='info-content-title'>
                                        {
                                          this.checkPropIsMust(item)?<i>*</i> : null
                                        }
                                        {item.Name}
                                        </span>
                                        <span style={{marginRight: "4px"}}>
                                        <DatePicker
                                        value={item.MeasureTemplates.LeftValue ? new Date(item.MeasureTemplates.LeftValue) : ''}
                                        placeholder="选择日期"
                                        format="yyyy-MM-dd"
                                        disabledDate={time=>time.getTime() > Date.now() }
                                        onChange={date=> this.changeDateTimeByDateTimeRange(item,date,"")}
                                        />
                                        </span>
                                       
                                         <DatePicker
                                          value={item.MeasureTemplates.RightValue ? new Date(item.MeasureTemplates.RightValue) :''}
                                          placeholder="选择日期"
                                          format="yyyy-MM-dd"
                                          disabledDate={time=>time.getTime() > Date.now()}
                                          onChange={date=>this.changeDateTimeByDateTimeRange(item,"",date)}
                                          />
                                      
                                     </li>
                                     : item.FieldType == "multiValueMeasure" ?
                                     <li className='info-content-left-li' >
                                        <span className='info-content-title' style={{width: '60px',textAlign:'left'}}>
                                        {
                                          this.checkPropIsMust(item)?<i>*</i> : null
                                        }
                                         {item.Name}
                                        </span>
                                        <div style={{width:"calc(100% - 58px)"}}>
                                        {
                                          item.MeasureTemplates.MultiValueMeasureList.map((mu,index) =>
                                           <div className='info-content-left-li-box' style={{marginBottom: "6px"}}>
                                              <SelectBox
                                               selectData={item.Options.map(x => { return { title: x } })}
                                               selectTitle={mu.Name}
                                               style={{minWidth: '130px'}}
                                               onchange={(selectItem) => { this.changeSelectCatePropsByMultiValueMeasure(item, selectItem.selectObj.title,mu.Index) }}
                                              >
                                              </SelectBox>
                                              <div className='info-content-left-li-input'>
                                                <input type="text" defaultValue={mu.Value}  style={{width:'50px'}}  placeholder="请输入" onChange={(e) => { this.changeCatePropsByMultiValueMeasure(item, e.target.value,mu.Index) }} />
                                                <span className='icon'>%</span>
                                              </div>
                                              
                                              {
                                                item.MeasureTemplates.MultiValueMeasureList.length != 1 ?
                                                <span className='iconfont icon-jian' style={{color:'#ff511c',marginLeft:'2px',marginRight:'2px'}} onClick={() => { this.reduceMultiValueMeasure(item,index) }}></span>
                                                :null
                                              }
                                              {
                                                index == item.MeasureTemplates.MultiValueMeasureList.length - 1 ?
                                                <span className='iconfont icon-jia-copy' onClick={() => { this.addMultiValueMeasure(item) }}></span>
                                                :null
                                              }
                                              
                                           </div>
                                          ) 
                                        }
                                       </div>

                                    </li>
                                  : null
                            )
                          }




                        </ul>
                      </div>
                      <div className="listingProductEditWrap-info-content-right">
                        <div style={{ backgroundColor: '#f5f5f5' }}>
                          <div className='info-content-right-li-title'>货源商品属性参考:</div>
                          <ul className="listingProductEditWrap-info-content-right-ul">
                            {/* <li><i className='dot'></i>材质:无纺布</li>
                        <li><i className='dot'></i>用途范围:日常防护</li>
                        <li><i className='dot'></i>材质:无纺布</li>
                        <li><i className='dot'></i>用途范围:日常防护</li> */}
                            {
                              this.state.sourceSupplierProduct && this.state.sourceSupplierProduct.Attributes ?
                                this.state.sourceSupplierProduct.Attributes.map((item) =>
                                  <li><i className='dot'></i><span style={{ flex: 1 }}>{item.AttributeName}:{item.AttributeValue}</span></li>
                                ) : null
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div> : null
              }


              {
                this.state.indexs == 1 ?
                  <div>
                    <div className="listingProductEditWrap-info-title">SKU&价格</div>
                    <div className='listingProductEditWrap-skuWrap'>
                      <ul className="listingProductEditWrap-skuWrap-ul">

                        {
                         
                          this.state.salesPropList.map((item) =>
                            <li className="listingProductEditWrap-skuWrap-ul-li" key={item.Name}>
                              <div className='skuWrap-ul-li-left'>{item.Name}：</div>
                              <div className='skuWrap-ul-li-right' style={{flexDirection:'column'}}>
                                {this.measure_templatesSaleExampleRender(item)}
                                <div className='skuWrap-ul-li-right'>
                                  {this.measure_templatesSaleRender(item)}
                                  {this.inputSaleRender(item)}
                                  {this.singleCheckSaleRender(item)}

                                  {
                                    !item.isAddSaleProp ?
                                      <span className='iconfont icon-jia-copy' onClick={() => { this.confirmAddSaleProp(item) }}></span> : null
                                  }
                                </div>

                              </div>
                            </li>
                          )
                        }
                      </ul>



                      <div className="listingProductEditWrap-skuWrap-table">
                        <div className="listingProductEditWrap-skuWrap-table-title">SKU列表</div>

                        <table className="table-style01">
                          <thead>
                            <tr>
                              <th style={{ minWidth: "150px" }}>颜色尺码</th>
                              <th style={{ minWidth: "80px" }}>来源价</th>
                              <th style={{ minWidth: "120px" }}>
                                <div className='batchWrap'>
                                  <span>价格</span>
                                  <div className='batchBtnSet' onClick={() => this.showBatchSetDailog('batchSetPriceDailog')}><span>批量设置</span>
                                    <i className="iconfont next-icon icon-xiangxia next-medium next-select-symbol-fold"></i>

                                  </div>
                                </div>
                              </th>
                              <th style={{ minWidth: "100px" }}>来源库存</th>
                              <th style={{ minWidth: "190px" }}>
                                <div className='batchWrap'>
                                  <span>现货可售库存</span>
                                  <div className='batchBtnSet' onClick={() => this.showBatchSetDailog('batchSetStockDailog')}><span>批量设置</span>
                                    <i className="iconfont next-icon icon-xiangxia next-medium next-select-symbol-fold"></i>
                                  </div>
                                </div>
                              </th>
                              {
                                this.state.supplierProduct.SkuClassificationRule && this.state.supplierProduct.SkuClassificationRule.enable ?
                                  <th style={{ minWidth: "200px" }}>

                                    <div className='batchWrap'>
                                      <span>SKU分类
                                        <i className='commonWenHao popoverCommon'>?<div className='popoverCommon-warn' style={{ width: '165px', maxWidth: '380px', bottom: '22px', lineHeight: '20px', color: '#333' }}>
                                          <div style={{ fontSize: '12px', width: '145px' }}>请务必对SKU完成分类标记，合理的标记可能会让您的商品获得更多曝光机会。有误的标记或者未标记，可能会影响商品的曝光流量获取以及宝贝信息展现。</div>
                                        </div>
                                        </i>
                                      </span>
                                      <select name="" id="" style={{ width: 150, marginLeft: 3 }} onChange={(e) => { this.batchSetSkuClassType(e.target.value) }}>
                                        {
                                          this.state.toutiaoSkuClassType.map((x) => {
                                            return <option value={x.value}>{x.name}</option>
                                          })
                                        }

                                      </select>
                                    </div>
                                </th>:null
                              }
                             

                            </tr>
                          </thead>
                          <tbody>
                            {
                              this.state.skuList.map((item) =>
                                <tr>
                                  <td>{item.AttributesList.join(',')}</td>
                                  <td>￥{item.SourcePrice}</td>
                                  <td>
                                    <label className='label-Wrap'>
                                      <span className='label-title'>￥</span>
                                      <input type="text" value={item.Price} onChange={(e) => { this.setPrice(item, e.target.value) }} />
                                    </label>
                                  </td>
                                  <td>{item.SourceAmountOnSale}</td>
                                  <td>
                                    <input type="text" value={item.AmountOnSale} onChange={(e) => { this.setStock(item, e.target.value) }} />
                                  </td>
                                  {
                                    this.state.supplierProduct.SkuClassificationRule && this.state.supplierProduct.SkuClassificationRule.enable ?
                                      <td>
                                        <select name="" id="" style={{ width: 150 }} value={item.SkuClassificationType} onChange={(e) => { this.setSkuClassType(item, e.target.value) }}>
                                          {
                                            this.state.toutiaoSkuClassType.map((x) => {
                                              return <option value={x.value}>{x.name}</option>
                                            })
                                          }
                                        </select>
                                      </td>:null
                                  }
                                  
                                </tr>
                              )
                            }

                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div> : null
              }


              {
                this.state.indexs == 2 ?
                <div>
                    <div style={{ paddingLeft: '28px', color: '#333' }} className="listingProductEditWrap-info-title">图片</div>
                    <div className='listingProductEditWrap-imageWrap'>
                        <div style={{ marginLeft: '23px' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ color: '#EA572E' }}>*</span>
                                <span style={{ fontSize: '12px', color: '#333' }}>主图</span>
                                <span className='listingProductEditWrap-image-tip'>已上传{this.state.productImages.length}/5张，格式支持png/jpeg/jpg，大小小于2M</span>
                            </div>
                            <div style={{ marginLeft: '37px', display: 'flex', alignItems: 'center', marginTop: '12px' }}>
                                {
                                    this.state.productImages.length < 5 ? <div className='listingProductEditWrap-imageUpload'>
                                        <input id="productImagesUpload" type="file" multiple accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageChange(event, 0)} />
                                        <span>+</span>
                                    </div> : null
                                }
                                {
                                    this.state.productImages && this.state.productImages.length > 0 ?
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {this.state.productImages.map((image, index) => (
                                                <div key={index} className='listingProductEditWrap-imageboxs'>
                                                    <img src={image} />
                                                    <i className='el-icon-circle-cross image_delect-icon' title='删除' onClick={() => this.handleImageDelete(0, index)}></i>
                                                    <i className='el-icon-view image_view-icon' title='预览' onClick={() => this.onHandleImageView(0, index)}></i>
                                                    <i className='el-icon-upload image_replace-icon' title='切换'>
                                                        <input type="file" accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageReplace(event, 0, index)} />
                                                    </i>
                                                </div>
                                            ))}
                                        </div> : null
                                }
                            </div>
                        </div>
                        <div style={{ marginLeft: '11px' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {this.state.isMustProductThreeAndFourImages ? 
                                <span style={{ color: '#EA572E' }}>*</span> : null
                                }
                                <span style={{ fontSize: '12px', color: '#333' }}>3:4主图</span>
                                <span className='listingProductEditWrap-image-tip'>已上传{this.state.productThreeAndFourImages.length}/5张，格式支持png/jpeg/jpg，大小小于2M</span>
                            </div>
                            <div style={{ marginLeft: '48px', display: 'flex', alignItems: 'center', marginTop: '12px' }}>
                                {
                                    this.state.productThreeAndFourImages.length < 5 ? <div className='listingProductEditWrap-imageUpload'>
                                        <input type="file" multiple accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageChange(event, 1)} />
                                        <span>+</span>
                                    </div> : null
                                }
                                {
                                    this.state.productThreeAndFourImages && this.state.productThreeAndFourImages.length > 0 ?
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {this.state.productThreeAndFourImages.map((image, index) => (
                                                <div key={index} className='listingProductEditWrap-imageboxs'>
                                                    <img src={image} />
                                                    <i className='el-icon-circle-cross image_delect-icon' onClick={() => this.handleImageDelete(1, index)}></i>
                                                    <i className='el-icon-view image_view-icon' title='预览' onClick={() => this.onHandleImageView(1, index)}></i>
                                                    <i className='el-icon-upload image_replace-icon' title='切换'>
                                                        <input type="file" accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageReplace(event, 1, index)} />
                                                    </i>
                                                </div>
                                            ))}
                                        </div> : null
                                }
                            </div>
                        </div>
                        <div style={{ marginLeft: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontSize: '12px', color: '#333' }}>白底图</span>
                                <span className='listingProductEditWrap-image-tip'>已上传{this.state.whiteBackgroundImages.length}/1张，格式支持png/jpeg/jpg，大小小于2M</span>
                            </div>
                            <div style={{ marginLeft: '43px', display: 'flex', alignItems: 'center', marginTop: '12px' }}>
                                {
                                    this.state.whiteBackgroundImages.length < 1 ? <div className='listingProductEditWrap-imageUpload'>
                                        <input type="file" multiple accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageChange(event, 2)} />
                                        <span>+</span>
                                    </div> : null
                                }
                                {
                                    this.state.whiteBackgroundImages && this.state.whiteBackgroundImages.length > 0 ?
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {this.state.whiteBackgroundImages.map((image, index) => (
                                                <div key={index} className='listingProductEditWrap-imageboxs'>
                                                    <img src={image} />
                                                    <i className='el-icon-circle-cross image_delect-icon' onClick={() => this.handleImageDelete(2, index)}></i>
                                                    <i className='el-icon-view image_view-icon' title='预览' onClick={() => this.onHandleImageView(2, index)}></i>
                                                    <i className='el-icon-upload image_replace-icon' title='切换'>
                                                        <input type="file" accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageReplace(event, 2, index)} />
                                                    </i>
                                                </div>
                                            ))}
                                        </div> : null
                                }
                            </div>
                        </div>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ color: '#EA572E' }}>*</span>
                                <span style={{ fontSize: '12px', color: '#333' }}>商品详情</span>
                                <span className='listingProductEditWrap-image-tip'>已上传{this.state.productDetailImages.length}/50张，格式支持png/jpeg/jpg，大小小于2M</span>
                            </div>
                            <div style={{ marginLeft: '61px', display: 'flex', marginTop: '12px' }}>
                                {
                                    this.state.productDetailImages.length < 50 ? <div className='listingProductEditWrap-imageUpload'>
                                        <input type="file" multiple accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageChange(event, 3)} />
                                        <span>+</span>
                                    </div> : null
                                }
                                {
                                    this.state.productDetailImages && this.state.productDetailImages.length > 0 ?
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                            {this.state.productDetailImages.map((image, index) => (
                                                <div key={index} className='listingProductEditWrap-imageboxs' style={{marginBottom: '16px'}}>
                                                    <img src={image} />
                                                    <i className='el-icon-circle-cross image_delect-icon' onClick={() => this.handleImageDelete(3, index)}></i>
                                                    <i className='el-icon-view image_view-icon' title='预览' onClick={() => this.onHandleImageView(3, index)}></i>
                                                    <i className='el-icon-upload image_replace-icon' title='切换'>
                                                        <input type="file" accept="image/png, image/jpeg, image/jpg" onChange={(event) => this.handleImageReplace(event, 3, index)} />
                                                    </i>
                                                </div>
                                            ))}
                                        </div> : null
                                }
                            </div>
                        </div>
                    </div>
                </div> : null
            }


            </div>
          </div>

          <div className="listingProductEditWrap-footer">

            <Button size='small' class="next-btn next-medium next-btn-normal next-dialog-btn" onClick={() => this.queryProduct()}>查看货源</Button>
            <Button size='small' class="next-btn next-medium next-btn-normal next-dialog-btn" onClick={() => this.saveProductEdit(false)}>保存</Button>
            {
              this.state.products && this.state.products.taskCode ?
              <Button size='samll' type='primary' class="next-btn next-medium next-btn-primary next-dialog-btn" onClick={() => this.saveProductEdit(true)}>保存并重新铺货</Button>
              :null
            }
          </div>

        </div>

        {this.state.openImageBigModal && (
            <div className="ImageBigModal_modal" onClick={() => this.onCloseImageBigModal(false)}>
                <img src={this.state.currentImage} alt="Enlarged" className="ImageBigModal_modal-content" onClick={(e) => e.stopPropagation()} />
            </div>
        )}

        <ShowModal
          width={'500px'}
          showModal={this.state.batchSetPriceDailog}
          sureBtnName={'应用价格'}
          sureDailog={() => this.batchSetPrice()}
          cancelDailog={() => this.cancelModule("batchSetPriceDailog")}>
          <div className="showModalWrap-box-commonContent">
            <ul className='batchSetPriceWrap' style={{ marginBottom: '60px' }}>
              <li className='batchSetPriceWrap-item'>
                <input type="radio" name='batchSetPriceRadio' value={'unifiedPrice'} defaultChecked={true}/>
                <span className='batchSetPriceWrap-item-title'>统一价格：</span>
                <input type="text" placeholder='请输入新商品价格' id='unifiedPrice' style={{ width: '360px' }} />
              </li>
              <li className='batchSetPriceWrap-item'>
                <input type="radio" name='batchSetPriceRadio' value={'comparePrice'} />
                <span className='batchSetPriceWrap-item-title'>公式计算：<s>当前价格<i>×</i></s></span>
                <input type="text" id='comparePriceRatio' />%<i>+</i>
                <input type="text" id='comparePriceAdd' />
                {/* <i>-</i><input type="text" value={0} /> */}
              </li>
              <li className='batchSetPriceWrap-item'>
                <input type="radio" name='batchSetPriceRadio' value={'compareSourcePrice'} />
                <span className='batchSetPriceWrap-item-title'>公式计算：<s>来源价格<i>×</i></s></span>
                <input type="text" id='compareSourcePriceRatio' />%<i>+</i>
                <input type="text" id='compareSourcePriceAdd' />
                {/* <i>-</i><input type="text" value={0} /> */}
              </li>

              <li className='batchSetPriceWrap-item' style={{ flexDirection: 'column',alignItems:'flex-start' }}>
                <div className='batchSetPriceWrap-item-up'>
                  <input type="radio" name='batchSetPriceRadio' value={'setDecimals'} />
                  <span className='batchSetPriceWrap-item-title'>设置小数：</span>
                  <input type="text" style={{ width: '360px' }} id='setDecimals' />
                </div>
                <div className='batchSetPriceWrap-item-down'>
                  <span>批量修改小数点后的数字</span>
                  <span>例如商品价格为15.45，设置9，商品价格为15.9</span>
                </div>
              </li>
            </ul>
          </div>
        </ShowModal>


        <ShowModal
          width={'450px'}
          showModal={this.state.batchSetStockDailog}
          sureBtnName={'应用现货可售库存'}
          sureDailog={() => this.batchSetStock()}
          cancelDailog={() => this.cancelModule("batchSetStockDailog")}>
          <div className="showModalWrap-box-commonContent">
            <ul className='batchSetPriceWrap' style={{ marginBottom: '60px' }}>
              <li className='batchSetPriceWrap-item' style={{ justifyContent: "flex-start" }}>
                <input type="radio" name='batchSetStockRadio' value='unifiedStock'  defaultChecked={true}/>
                <span className='batchSetPriceWrap-item-title'>统一将设置库存为：</span>
                <input type="text" style={{ width: '250px' }} id='unifiedStock' />
              </li>

              <li className='batchSetPriceWrap-item' style={{ justifyContent: "flex-start" }}>
                <input type="radio" name='batchSetStockRadio' value='addStock' />
                <span className='batchSetPriceWrap-item-title'>原库存基础上增加：</span>
                <input type="text" style={{ width: '250px' }} id='addStock' />
              </li>
              <li className='batchSetPriceWrap-item' style={{ justifyContent: "flex-start" }}>
                <input type="radio" name='batchSetStockRadio' value='reduceStock' />
                <span className='batchSetPriceWrap-item-title'>原库存基础上减少：</span>
                <input type="text" style={{ width: '90px' }} id='reduceStock' />
                <i style={{ margin: '0 5px', fontSize: '12px' }}>且不少于</i>
                <input type="text" style={{ width: '90px' }} id='reduceStockLimit' />
              </li>
              <li className='batchSetPriceWrap-item' style={{ justifyContent: "flex-start" }}>
                <input type="radio" name='batchSetStockRadio' value='sameStock' />
                <span className='batchSetPriceWrap-item-title'>和源库存保持一致</span>
              </li>
              <li className='batchSetPriceWrap-item' style={{ justifyContent: "flex-start" }}>
                <input type="checkbox" id='batchSetStockZeroCheckbox' />
                <span className='batchSetPriceWrap-item-title' style={{ color: '#ff511c' }}>库存为[0]的不做调整</span>
              </li>
            </ul>
          </div>
        </ShowModal>
        <ShowModal
          width={'450px'}
          showModal={this.state.confirmUpdateCategory}
          sureBtnName={'修改类目'}
          sureDailog={() => this.confirmChangeCategory()}
          cancelDailog={() => this.cancelModule("confirmUpdateCategory")}>
          <div className="showModalWrap-box-commonContent">
            <div>
              修改类目可能会导致部分内容丢失，确认修改？
            </div>
          </div>
        </ShowModal>



        {/* 添加一个 加载的弹窗遮罩，后台任务式查询(先临时放一个) */}
        <Loading isLoading={this.state.isLoading} hasBorder={false} isShade={false} isStopOperate={true} title="加载中" />



      </div>

    );
  }



};

export default ListingProductEditV2;



// WEBPACK FOOTER //
// ./src/components/listingProductEditV2/index.jsx